import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledFeedPage = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  color: ${({ theme }) => theme.colors.text};
  border: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 80px 20px 110px;
  overflow-y: auto;
  gap: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10% 40px;
    align-items: center;
    gap: 32px;
  }
  h1 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    width: 100%;
    margin: 0;
  }
`;

export const StyledFeedBlock = styled(Link)`
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.card};
  border-radius: 22px;
  object-fit: cover;
  position: relative;
  display: flex;
  width: 100%;
  min-width: 100%;
  height: clamp(220px, 55vw, 360px);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 30%;
    min-width: 30%;
    height: 360px;
    scroll-snap-align: start;
  }
  box-shadow: ${({ theme }) =>
    theme.colors.background === "#171717"
      ? theme.boxShadows.dark
      : theme.boxShadows.light};
  &:hover {
    transform: translateY(-6px);
  }
  img {
    border-radius: inherit;
    object-fit: cover;
    height: 100%;
    width: 100%;
    transition: transform 0.6s ease;
  }
  &:hover img {
    transform: scale(1.05);
  }
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(
      180deg,
      rgba(4, 10, 20, 0.05) 0%,
      rgba(4, 10, 20, 0.75) 100%
    );
    pointer-events: none;
  }
  h4 {
    z-index: 1;
    position: absolute;
    margin: 0;
    bottom: 18px;
    left: 18px;
    right: 18px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 1.3;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .guideBook {
    z-index: 1;
    position: absolute;
    left: 18px;
    bottom: 60px;
    background-color: rgba(255, 255, 255, 0.9);
    color: ${({ theme }) => theme.colors.primary};
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
`;

export const StyledHorizontalCarousel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
  padding: 10px 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: flex-start;
    overflow-x: auto;
    padding: 10px 0 10px 2px;
    gap: 18px;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
  }
`;
